
<ng-container *ngIf="deposite && summary && garages">
  <div class="row">
    <div class="col-12 ">
      <h1>Relokacja depozytu.</h1>
    </div>
    <div class="col-12 ">
      <h1>Wybierz serwis docelowy na mapie.</h1>
    </div>
  </div>

  <google-map *ngIf="mapsLoaded" #map height="600px" width="100%"
              [center]="{ lat: selectedMarker.Lat, lng: selectedMarker.Lng }"
              [zoom]="Zoom"
              (zoomChanged)="onZoomChange(map.getZoom())">
    <map-marker *ngFor="let m of Markers; let i = index"
                [position]="{ lat: m.Lat, lng: m.Lng }"
                [options]="{ label: m.Label, title: m.Title, icon: '/assets/img/Google.png' }"
                (mapClick)="onMarkerClik(m)">
    </map-marker>
  </google-map>
</ng-container>


  <ng-container *ngIf="selectedGarage">
    <p-dialog [(visible)]="isVisibleDialogRelocation"
              [modal]="true" [style]="{width:'80vw'}" [baseZIndex]="1000"
              [draggable]="false" [resizable]="false" [showHeader]="false"
              styleClass="disable-scroll">


      <div class="container z-index-master" *ngIf="requestRelocatoinOrderSave.IsProcessing">
        <div class="row align-items-center">
          <div class="col-md-12">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
              <span class="sr-only">Rejestracja nowego zlecenia...</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="!requestRelocatoinOrderSave.IsProcessing">
        <div class="col-12 menu-box-text p-1">Wybrany serwis docelowy</div>
        <div class="col-12 relocation-dialog-text">{{ selectedGarage.Name}}</div>
        <div class="col-12 relocation-dialog-text">{{ selectedGarage.City}}</div>
        <div class="col-12 relocation-dialog-text">{{ selectedGarage.Street}}</div>
        <div class="col-12 relocation-dialog-text" *ngIf="selectedGarage.Telephone && selectedGarage.Telephone.length > 1">tel: {{ selectedGarage.Telephone}}</div>
      </div>

      <div class="mt-2" *ngIf="!requestRelocatoinOrderSave.IsProcessing">
        <button class="btn btn-sm btn-primary ml-1" (click)="onCancelRelocationClick()">Anuluj</button>
        <button class="btn btn-sm btn-primary ml-1" (click)="onConfirmRelocationClick()">Zleć relokację</button>
      </div>
    </p-dialog>
  </ng-container>


  <ng-container *ngIf="!summary || !deposite || !garages">
    <div class="container z-index-master">
      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
